import React from 'react';
import { IconProps } from '../../types/icon';

const JsonIcon: React.FC<IconProps> = ({ className, size = 16 }) => {
  return (
    <img
      src="/gitex-illustrations/JsonIcon.png"
      alt="JSON File"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default JsonIcon;